import { call, put, takeEvery } from "redux-saga/effects";
import CutoffLunchMenuService from "../../../services/admin/cutoffLunchMenu";
import { cutoffLunchMenuList } from "../../actionCreators/admin/cutoffLunchMenu";
import { GET_CUTOFF_LUNCH_MENU_WATCHER, SAVE_CUTOFF_LUNCH_MENU_WATCHER, DELETE_CUTOFF_LUNCH_MENU_WATCHER } from "../../actionTypes/admin";
import { updateFalseLoader, updateOpenLoader } from "../../actionCreators/spinner";
import { updateAlert } from "../../actionCreators/alert";
import { errorMessage } from "../../../utils/errorMessage";


function* getCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.getAll, action.payload);

    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(errorMessage(e, 'Something Went Wrong'), 'error'));
  }
}

function* saveCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.save, action.payload);

    if (action.setOpen) action.setOpen(false)
    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert(action.payload.ACTION === 'UPDATE' ? 'Updated Successfully' : 'Created Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

function* deleteCutoffLunchMenuEffect(action) {
  try {
    yield put(updateOpenLoader());
    let { data } = yield call(CutoffLunchMenuService.delete, action.id);

    yield put(cutoffLunchMenuList(data.recordset));
    yield put(updateFalseLoader());
    yield put(updateAlert('Deleted Successfully', 'success'));
  } catch (e) {
    yield put(updateFalseLoader());
    yield put(updateAlert(e.response?.data?.message || 'Something Went Wrong', 'error'));
  }
}

//saga
export const CutoffLunchMenuSaga = [
  takeEvery(GET_CUTOFF_LUNCH_MENU_WATCHER, getCutoffLunchMenuEffect),
  takeEvery(SAVE_CUTOFF_LUNCH_MENU_WATCHER, saveCutoffLunchMenuEffect),
  takeEvery(DELETE_CUTOFF_LUNCH_MENU_WATCHER, deleteCutoffLunchMenuEffect)
]
